import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { isEmpty } from 'lodash';

import { operations as generalReportOperations } from '../../../state/modules/general-reports';
import { selectors as generalReportSelectors } from '../../../state/modules/general-reports';
import TableReport from './TableReport';
import Loader from '../../general/Loader';
import { unpackFromLocalStorage, addToLocalStorage } from '../../../utils/local-storage';

import FilterModal from './FilterModal';

const GeneralReport = ({
  fetchArchetype,
  fetchData,
  reportType,
  filters,
  reportData,
  loading,
  defaultColumnKeys,
  columnsByKey
}) => {
  const [selectedColumns, setSelectedColumns] = useState(
    unpackFromLocalStorage(`general_report_${reportType}_columns`) || null
  );
  const [showFilters, setShowFilters] = useState(false);

  if (!filters) filters = {};

  const fetchReportData = fileType =>
    fetchData({
      params: { ...filters, cols: (selectedColumns || []).join(','), file_type: fileType },
      reportType
    });

  useEffect(() => {
    fetchArchetype(reportType, filters['group_id']);
    fetchReportData();
  }, []);

  useEffect(() => {
    if (selectedColumns !== null || isEmpty(defaultColumnKeys)) return;
    setSelectedColumns(defaultColumnKeys);
  }, [selectedColumns, defaultColumnKeys]);

  const setSelectedColumnsAndSave = newSelectedColumns => {
    setSelectedColumns(newSelectedColumns);
    addToLocalStorage(`general_report_${reportType}_columns`, newSelectedColumns);
  };

  const exportToCSV = () => fetchReportData('csv');
  const exportToXLSX = () => fetchReportData('xlsx');

  const columnKeys = isEmpty(reportData) ? [] : Object.keys(reportData[0]);

  if (!reportData || !selectedColumns || loading) return <Loader />;

  return (
    <>
      <TableReport
        columnsByKey={columnsByKey}
        data={reportData}
        columnKeys={columnKeys}
        handleShowFilters={() => setShowFilters(true)}
        exportToCSV={exportToCSV}
        exportToXLSX={exportToXLSX}
      />
      <FilterModal
        selectedColumns={selectedColumns}
        columnsByKey={columnsByKey}
        fetchData={fetchReportData}
        show={showFilters}
        setShow={setShowFilters}
        setSelectedColumns={setSelectedColumnsAndSave}
        defaultColumnKeys={defaultColumnKeys}
      />
    </>
  );
};

const mapStateToProps = state => ({
  reportData: generalReportSelectors.data(state),
  loading: generalReportSelectors.loading(state),
  columnsByKey: generalReportSelectors.columnsByKey(state),
  defaultColumnKeys: generalReportSelectors.defaultColumnKeys(state)
});

const mapDispatchToProps = {
  fetchArchetype: generalReportOperations.fetchArchetype,
  fetchData: generalReportOperations.fetchData
};

export default connect(mapStateToProps, mapDispatchToProps)(GeneralReport);
